import { render, staticRenderFns } from "./map.vue?vue&type=template&id=52b2989a&scoped=true&"
import script from "./map.vue?vue&type=script&lang=js&"
export * from "./map.vue?vue&type=script&lang=js&"
import style0 from "./map.vue?vue&type=style&index=0&id=52b2989a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b2989a",
  null
  
)

export default component.exports